import React, {useState} from 'react';
import {Button, message} from 'antd';
import {PreviewModal} from '../PreviewModal';
import {uploadService} from '../../services/upload';
import {getObsKey} from '../../utils/filePreview';
import {EyeOutlined} from '@ant-design/icons';

export function PreviewButton({
                                file,
                                children,
                                className
                              }: {
  file: any;
  children?: React.ReactNode;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [loading, setLoading] = useState(false);

  async function handlePreview(e?: React.MouseEvent) {
    e?.stopPropagation();

    const obskey = getObsKey(file);

    if (!obskey) {
      void message.warning('暂无预览地址');
      return;
    }

    setLoading(true);

    try {
      const res = await uploadService.getTempDownloadUrl({obskey});
      const url = typeof res === 'string' ? res : res?.data;

      if (!url) {
        void message.warning('获取预览地址失败');
        return;
      }

      setPreviewUrl(url);
      setOpen(true);
    } catch (err) {
      void message.warning('预览失败');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {children ? (
        <span
          className={className}
          onClick={handlePreview}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            minWidth: 0
          }}
        >
          {children}
        </span>
      ) : (
        <Button
          type="text"
          size="small"
          icon={<EyeOutlined/>}
          loading={loading}
          onClick={handlePreview}
        />
      )}

      <PreviewModal
        open={open}
        file={file}
        url={previewUrl}
        onCancel={() => setOpen(false)}
      />
    </>
  );
}